import { createReducer, on } from '@ngrx/store';
import { Box } from '@app/store/placed-boxes/models';
import { cartonsActions } from '../actions/cartons.actions';
import { CartonsStatus } from '../models';

export interface CartonsState {
    boxes: Box[];
    status: CartonsStatus;
    page: number;
    hasMore: boolean;
    loaded: boolean | null;
    loading: boolean | null;
}

export const initialState: CartonsState = {
    boxes: [],
    status: 'open',
    page: 0,
    hasMore: false,
    loaded: null,
    loading: null,
};

export const cartonsReducer = createReducer(
    initialState,
    on(cartonsActions.loadCartons, (state, { status }): CartonsState => ({
        ...state,
        status,
        loading: true,
        loaded: null,
    })),
    on(cartonsActions.loadCartonsSuccess, (state, { payload, page, hasMore }): CartonsState => ({
        ...state,
        loading: false,
        loaded: true,
        page,
        hasMore,
        boxes: page === 1 ? payload : [...state.boxes, ...payload.filter((box) => !state.boxes.some((item) => item.id === box.id))],
    })),
    on(cartonsActions.loadCartonsError, (state): CartonsState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    on(cartonsActions.clear, (): CartonsState => ({ ...initialState })),
);
